import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const OtherDocumentType = {
    list: async () => axios.post(API_URL + "/otherDocumentTypes/list").then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_URL + `/otherDocumentType/${id}`).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_URL + `/otherDocumentTypes`, data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.post(API_URL + `/otherDocumentTypes/${id}`, data).then(({data}) => data).catch((err) => { throw err }),

    destroy: async (id) => axios.delete(API_URL + `/otherDocumentTypes/${id}`).then(({data}) => data).catch((err) => { throw err }),
}

export default OtherDocumentType;
